/**
 * Username Availability Checker
 * Real-time username validation for registration forms
 * 
 * @since 3.7.0
 */

(function($) {
    'use strict';

    // Debounce function to limit API calls
    function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    /**
     * Check username availability
     */
    function checkUsernameAvailability(username, $field) {
        // Remove previous status
        $field.removeClass('checking available taken');
        
        // Validate username format first
        if (username.length < 3) {
            return;
        }

        // Add checking state
        $field.addClass('checking');

        // AJAX request to check availability
        $.ajax({
            url: front_end_data.admin_ajax,
            type: 'POST',
            data: {
                action: 'simpleform_check_username',
                nonce: front_end_data.nonce,
                username: username
            },
            success: function(response) {
                $field.removeClass('checking');
                
                if (response.success) {
                    if (response.data.available) {
                        $field.addClass('available');
                    } else {
                        $field.addClass('taken');
                    }
                }
            },
            error: function() {
                $field.removeClass('checking');
            }
        });
    }

    // Debounced version
    const debouncedCheck = debounce(checkUsernameAvailability, 500);

    /**
     * Initialize username checker
     */
    function initUsernameChecker() {
        // Find username fields with availability check class
        const $usernameFields = $('.simpleform-check-availability, input[name="username"]').filter(function() {
            // Only in registration forms
            return $(this).closest('form').find('input[name="password"], input[name="confirm_password"]').length > 0;
        });

        $usernameFields.each(function() {
            const $field = $(this);
            
            // Add wrapper for positioning
            if (!$field.parent().hasClass('username-field-wrapper')) {
                $field.wrap('<div class="username-field-wrapper"></div>');
            }

            // Listen for input changes
            $field.on('input', function() {
                const username = $(this).val().trim();
                
                if (username.length >= 3) {
                    debouncedCheck(username, $field);
                } else {
                    $field.removeClass('checking available taken');
                }
            });

            // Check on blur if value exists
            $field.on('blur', function() {
                const username = $(this).val().trim();
                if (username.length >= 3 && !$field.hasClass('available') && !$field.hasClass('taken')) {
                    checkUsernameAvailability(username, $field);
                }
            });
        });
    }

    // Initialize on document ready
    $(document).ready(function() {
        initUsernameChecker();
    });

    // Re-initialize when new forms are loaded dynamically
    $(document).on('simpleform_loaded', function() {
        initUsernameChecker();
    });

})(jQuery);
